export default "__VITE_PUBLIC_ASSET__614774d9__"